export function ab2str(buf) {
    var string = new TextDecoder().decode(new Uint16Array(buf));
    return string;
}

export function ab2str2(buf) {
    return new Promise((resolve) => {
        var bb = new Blob([new Uint8Array(buf)]);
        var f = new FileReader();
        f.onload = function(e) {
            resolve(e.target.result);
        };
        f.readAsText(bb);
    });
}

export function str2ab(str) {
    var buf = new ArrayBuffer(str.length*2); // 2 bytes for each char
    var bufView = new Uint16Array(buf);
    for (var i=0, strLen=str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
}
